import { render } from "./MissedVisit.vue?vue&type=template&id=56dfc6ff"
import script from "./MissedVisit.ts?vue&type=script&lang=js&external"
export * from "./MissedVisit.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__